import styled from 'styled-components';

export default styled.div`
  padding: 4px;
  background-color: var(--grey100);
  position: relative;
  min-height: 50px;
  overflow: hidden;
  border-radius: 0 0 8px 8px;
`;
